var fontWeights = {
  black: 900,
  bolder: 700,
  bold: 600,
  medium: 500,
  regular: 400,
  light: 300,
  thin: 100
};

export { fontWeights as default };
